const elements = {
  triggers: document.body.querySelectorAll('.js-to-top-trigger'),
};

const scrollToTop = () => {
  const c = document.documentElement.scrollTop || document.body.scrollTop;
  if (c > 0) {
    window.requestAnimationFrame(scrollToTop);
    window.scrollTo(0, c - (c / 10));
  }
};

function init() {
  if (elements.triggers.length) {
    Array.prototype.forEach.call(elements.triggers, (el) => {
      el.addEventListener('click', () => {
        scrollToTop();
      });
    });
  }
}

export default init;



// WEBPACK FOOTER //
// ./src/components/components/entrade/_to-top/to-top.js